export { default } from './PrepareDisclosuresWizardFooter';
